//React
import { Redirect, Route } from "react-router-dom";
// Ionic
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import {
  calendar,
  bookmarkOutline,
  searchOutline,
  person,
  navigateCircleOutline, listOutline
} from "ionicons/icons";



//Pages
import Search from "./pages/Search";
import Login from "./pages/Login";
import UserProfile from "./pages/UserProfile";
import SinglePitch from "./pages/SinglePitch";
import Buttons from "./pages/Buttons";
import Bookmarks from "./pages/Bookmarks";
import Routen from "./pages/Route";
import MobileCallback from "./pages/MobileCallback";
/*
import MenuContent from "./components/Header/MenuContent";
*/

import userService from "./Context/user.service";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./theme/index.css";

/* Bootstrap for grid use */
import "bootstrap/dist/css/bootstrap-grid.min.css";

setupIonicReact();

const App: React.FC = () => (

  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet id="main">
        {/* <Route path="/home" component={Home} exact={true} />
        <Route path="/login" component={Login} exact={true} />
        <Route path="/profil" component={UserProfile} exact={true} />
        <Route path="/buttons" component={Buttons} exact={true} />*/}

      </IonRouterOutlet>

      <IonTabs>
        <IonRouterOutlet>
          <Route path="/map/login" component={Login} exact={true} />
          <Route path="/map/mobile-callback" exact>
            <MobileCallback />
          </Route>
          <Route path="/map/buttons" component={Buttons} exact={true} />
          <Route path="/map/home" component={Search} exact={true} />
          <Route path="/map/suche" component={Search} exact={true} />
          <Route path="/map/" component={Search} exact={true} />
          <Route path="/map/profil" component={UserProfile} exact={true} />

          <Route path="/map/merkliste">
            <Bookmarks />
          </Route>

          <Route path="/map/routenplanung/">
            <Routen />
          </Route>
          <Route path="/map/route/">
            <Routen />
          </Route>
          <Route path="/map/route/:id">
            <Routen />
          </Route>
          <Route path="/map/pitch/:id">
            <SinglePitch />
          </Route>
          <Route exact path="/map/" render={() => <Redirect to="/map/home" />} />
          <Route exact path="/" render={() => <Redirect to="/map/" />} />
        </IonRouterOutlet>
        <IonTabBar slot="bottom">
          <IonTabButton tab="tab1"  onClick={() => userService.goToURL("/app/routenplanung")}>
          <svg className="icon__route__menuMobile" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#999999" d="M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>
            <IonLabel>Route</IonLabel>
          </IonTabButton>
          <IonTabButton tab="tab2" onClick={() => userService.goToURL("/app/merkliste")}>
            <IonIcon icon={bookmarkOutline} />
            <IonLabel>Merkliste</IonLabel>
          </IonTabButton>
          <IonTabButton tab="tab3" href="/map/home">
            <IonIcon icon={searchOutline} />
            <IonLabel>Suche</IonLabel>
          </IonTabButton>
          <IonTabButton tab="account" href="/map/profil">
            <IonIcon icon={listOutline} />
            <IonLabel>Mein Profil</IonLabel>
          </IonTabButton>
        </IonTabBar>
      </IonTabs>
    </IonReactRouter>
  </IonApp>
);

export default App;
